import { useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { request, toast } from '../../utils';
// import { OPDBillingPDF } from './options/Hospital/HMS/OPDBillingPDF';
// import { IPDBillingPDF } from './options/Hospital/HMS/IPDBillingPDF';
// import { PatientRegisterationPDF } from './options/Hospital/HMS/PatientRegisterationPDF';
import * as HospitalHMS from './options/Hospital/HMS';
import * as HospitalLIS from './options/Hospital/LIS';
import * as HospitalDoctorWorkBench from './options/Hospital/DoctorWorkBench';
import * as HospitalPharmacy from './options/Hospital/Pharmacy';
import * as GeneralLedger from './options/Hospital/GeneralLedger';
import * as HospitalRadiology from './options/Hospital/Radiology';
import * as HospitalIVF from "./options/Hospital/IVF"
import * as HospitalStoreManagement from "./options/Hospital/StoreManagement"
import * as HospitalTPA from "./options/Hospital/TPA"

const getPathMode = (path = '') => {
  return path.replace('/print/', '').split('/').join('.');
};

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const printOption = user ? user.printOption : 0;

const getDynamicComponent = (printoption) => {
  switch (printoption) {
    case 1:
      return HospitalHMS.PatientRegistrationPdf2;
    case 2:
      return HospitalHMS.PatientRegisterationPDF;
    case 3:
      return HospitalHMS.PatientRegistrationPdf3;
    case 4:
      return HospitalHMS.PatientRegistrationPdf4;
    case 5:
      return HospitalHMS.PatientRegisterationPdf6;
    case 6:
      return HospitalHMS.PatientRegistrationPdf7;
    case 7:
      return HospitalHMS.PatientRegistrationPdf8;
    case 8:
      return HospitalHMS.PatientRegistrationPdf9;
    case 9:
      return HospitalHMS.PatientRegistrationPdf10;
    case 10:
      return HospitalHMS.PatientRegisterationPdf11;
    case 11:
      return HospitalHMS.PatientRegisterationPdf12;
    case 12:
      return HospitalHMS.PatientRegisterationPdf13;
    case 13:
      return HospitalHMS.PatientRegistrationPdf14;
    case 14:
      return HospitalHMS.PatientRegistrationPdf15;
    case 15:
      return HospitalHMS.PatientRegistrationPdf16;
    case 16:
      return HospitalHMS.PatientRegistrationPdf17;
    case 17:
      return HospitalHMS.PatientRegistrationPdf18;
    case 18:
      return HospitalHMS.PatientRegistrationPdf19;
    case 19:
      return HospitalHMS.PatientRegistrationPdf20;
    case 20:
      return HospitalHMS.PatientRegistrationPdf21;
    default:
      return HospitalHMS.PatientRegistrationPdf1;
  }
};

const moduleLookup = {
  'hospital.outpatient-management.opd-billing': (data) => <HospitalHMS.OPDBillingPDF data={data} />,
  'hospital.health-checkup.opd-billing': (data) => <HospitalHMS.OPDBillingPDF data={data} />,
  'hospital.inpatient-management.indoor-service': (data) => <HospitalHMS.IPDBillingPDF data={data} />,

  'hospital.patient-admission.invoice-print': (data) => <HospitalHMS.PatientRegistrationInvoicePrint data={data} />,
  'hospital.patient-admission.emergency-print': (data) => <HospitalHMS.PatientRegistrationPdf5 data={data} />,
  'hospital.outpatient-management.patient-registeration.emergency-print': (data) => (
    <HospitalHMS.PatientRegistrationPdf5 data={data} />
  ),
  'hospital.outpatient-management.patient-registeration.invoice-print': (data) => (
    <HospitalHMS.PatientRegistrationInvoicePrint data={data} />
  ),
  'hospital.inpatient-management.indoor-registeration': (data) => <HospitalHMS.IndoorRegisterationPDF data={data} />,
  'hospital.inpatient-management.indoor-registeration.print1': (data) => (
    <HospitalHMS.IndoorRegistrationReportPdfPrint1 data={data} />
  ),
  'hospital.inpatient-management.indoor-registeration.label': (data) => (
    <HospitalHMS.IndoorRegisterationLabelPrint data={data} />
  ),
  'hospital.outpatient-management.collection-summary.ref-by-collection': (data) => <HospitalHMS.RefByCollectionSummaryReportPdf data={data} />,
  'hospital.outpatient-management.collection-summary': (data) => <HospitalHMS.CollectionSummaryReport data={data} />,
  'hospital.outpatient-management.collection-summary.user-wise': (data) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} />
  ),
  'hospital.outpatient-management.appointment-register-report': (data) => (
    <HospitalHMS.AppointmentRegisterReport data={data} />
  ),
  'hospital.patient-admission.collection-summary': (data) => <HospitalHMS.CollectionSummaryReport data={data} />,
  'hospital.patient-admission.collection-summary.ref-by-collection': (data) => <HospitalHMS.RefByCollectionSummaryReportPdf data={data} />,
  'hospital.patient-admission.collection-summary.user-wise': (data) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} />
  ),
  'hospital.outpatient-management.registration-register': (data) => (
    <HospitalHMS.RegistrationRegisterReport data={data} />
  ),
  'hospital.outpatient-management.doctor-master-report': (data) => <HospitalHMS.DoctorMasterReportPdf data={data} />,
  'hospital.outpatient-management.service-master-report': (data) => <HospitalHMS.ServiceMasterReportPdf data={data} />,
  'hospital.outpatient-management.service-package-report': (data) => (
    <HospitalHMS.ServicePackageReportPdf data={data} />
  ),
  'hospital.outpatient-management.consultant-wise-opd': (data) => (
    <HospitalHMS.ConsultantWiseOpdReportPdf data={data} />
  ),
  'hospital.outpatient-management.department-wise-opd': (data) => (
    <HospitalHMS.DepartmentWiseOpdReportPdf data={data} />
  ),
  'hospital.outpatient-management.sponsor-wise-opd': (data) => <HospitalHMS.SponsorWiseOpdReportPdf data={data} />,
  'hospital.outpatient-management.opd-patient-ledger': (data) => <HospitalHMS.OpdPatientLedgerPdf data={data} />,
  'hospital.outpatient-management.doctor-wise-opd-procedure-reports': (data) => (
    <HospitalHMS.DoctorWiseOpdProceduresReportPdf data={data} />
  ),
  'hospital.outpatient-management.due-payment-register': (data) => (
    <HospitalHMS.DuePaymentRegisterReportPdf data={data} />
  ),
  'hospital.inpatient-management.indoor-billing-management': (data) => (
    <HospitalHMS.IndoorBillManagementReportPdf data={data} />
  ),
  'hospital.inpatient-management.patient-discharge': (data) => <HospitalHMS.PatientDischargePdf data={data} />,
  'hospital.inpatient-management.credit-register-report': (data) => <HospitalHMS.CreditRegisterReportPdf data={data} />,
  'hospital.inpatient-management.balance-register-report': (data) => <HospitalHMS.BalanceRegisterReport data={data} />,
  'hospital.inpatient-management.bill-register-report': (data) => <HospitalHMS.BillRegisterReport data={data} />,
  'hospital.hr-management.generate-salary-slip': (data) => <HospitalHMS.SalarySlipPdf data={data} />,
  'hospital.inpatient-management.discount-register-report': (data) => (
    <HospitalHMS.DiscountRegisterReportPdf data={data} />
  ),
  'hospital.inpatient-management.service-register-report': (data) => (
    <HospitalHMS.ServiceRegisterReportPdf data={data} />
  ),
  'hospital.inpatient-management.doctor-ledger': (data) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} />
  ),
  'hospital.inpatient-management.doctor-ledger.summary': (data) => (
    <HospitalHMS.DoctorLedgerSummaryReportPdf data={data} />
  ),
  'hospital.inpatient-management.refund-register': (data) => <HospitalHMS.RefundRegisterReportPdf data={data} />,
  'hospital.inpatient-management.collection-analysis-report': (data) => (
    <HospitalHMS.CollectionAnalysisReportPdf data={data} />
  ),
  'hospital.inpatient-management.consultant-revenue-analysis-report': (data) => (
    <HospitalHMS.ConsultantRevenueAnalysisReportPdf data={data} />
  ),
  'hospital.inpatient-management.discharge-summary': (data) => <HospitalHMS.DischargeSummaryPDF data={data} />,
  'hospital.doctor-management.discharge-summary': (data) => <HospitalHMS.DischargeSummaryPDF data={data} />,
  'hospital.inpatient-management.receipt-voucher': (data) => <HospitalHMS.ReceiptVoucherPdf data={data} />,
  'hospital.inpatient-management.payment-refund-voucher': (data) => <HospitalHMS.PaymentRefundVocuherPdf data={data} />,
  'hospital.inpatient-management.active-patient-reports': (data) => (
    <HospitalHMS.IpdActivePatientReportPdf data={data} />
  ),
  'hospital.inpatient-management.ipd-admission-register-reports': (data) => (
    <HospitalHMS.IpdAdmissionRegisterReportPdf data={data} />
  ),
  'hospital.inpatient-management.ipd-discharge-register': (data) => (
    <HospitalHMS.IpdPatientDischargeReportPdf data={data} />
  ),
  'hospital.inpatient-management.indoor-collection-register': (data) => (
    <HospitalHMS.IndoorCollectionRegisterReportPdf data={data} />
  ),
  'hospital.outpatient-management.scheme-allotment': (data) => <HospitalHMS.SchemeAllotmentPdf data={data} />,
  'hospital.laboratory.result-entry': (data) => <HospitalLIS.ResultEntryPdf data={data} />,
  'hospital.laboratory.result-entry.print1': (data) => <HospitalLIS.ResultEntryPdf1 data={data} />,
  'hospital.laboratory.daily-investigation-report': (data) => <HospitalLIS.DailyInvestigationReport data={data} />,
  'hospital.laboratory.investigation-booking': (data) => <HospitalLIS.InvestigationBookingPdf data={data} />,
  'hospital.laboratory.sample-collection-report': (data) => <HospitalLIS.SampleCollectionReportPdf data={data} />,
  'hospital.laboratory.Uhid-IPD-No-Wise-report': (data) => <HospitalLIS.UhidIPDNoWiseReportPdf data={data} />,
  'hospital.doctor-management.opd-requisition': (data) => <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} />,
  'hospital.doctor-management.ipd-requisition': (data) => <HospitalDoctorWorkBench.IpdRequisitionPdf data={data} />,
  'hospital.opd-clinical-management.opd-requisition': (data) => (
    <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} />
  ),
  'hospital.emr.opd-requisition': (data) => <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} />,
  'hospital.doctor-management.opd-requisition.ProgressReport': (data) => (
    <HospitalDoctorWorkBench.OpdRequisitionProgressReportPdf data={data} />
  ),
  'hospital.doctor-management.ipd-requisition.ProgressReport': (data) => (
    <HospitalDoctorWorkBench.IpdRequisitionProgressReportPdf data={data} />
  ),
  'hospital.inpatient-management.sponsor-wise-ipd-report': (data) => (
    <HospitalHMS.SponsorWiseIpdReportPdf data={data} />
  ),
  'hospital.emr.opd-requisition.ProgressReport': (data) => (
    <HospitalDoctorWorkBench.OpdRequisitionProgressReportPdf data={data} />
  ),
  'hospital.inventory.retail-sale-pos': (data) => <HospitalPharmacy.RetailSalePosPDF data={data} />,
  'hospital.tally.gst-report': (data) => <GeneralLedger.GstReportPdf data={data} />,
  'hospital.inventory.gst-report': (data) => <HospitalPharmacy.GstReportPdf data={data} />,
  'hospital.inventory.batch-wise-expired-item': (data) => (
    <HospitalPharmacy.BatchWiseExpriredItemReportPdf data={data} />
  ),
  'hospital.inventory.batch-wise-near-expiring-item': (data) => (
    <HospitalPharmacy.BatchWiseExpriredItemReportPdf data={data} />
  ),
  'hospital.inventory.stock-status': (data) => <HospitalPharmacy.StockStatusReportPdf data={data} />,
  'hospital.inventory.stock-status.group': (data) => <HospitalPharmacy.StockStatusReportPdf data={data} />,
  'hospital.inventory.stock-status.subgroup': (data) => <HospitalPharmacy.StockStatusReportPdf data={data} />,
  'hospital.inventory.stock-status.category': (data) => <HospitalPharmacy.StockStatusReportPdf data={data} />,
  'hospital.inventory.stock-status.salt': (data) => <HospitalPharmacy.StockStatusReportPdf data={data} />,

  'hospital.inventory.item-wise-sale-reort-register': (data) => (
    <HospitalPharmacy.ItemWiseSaleReortRegisterPdf data={data} />
  ),
  'hospital.inventory.grn-report': (data) => <HospitalPharmacy.GrnPdf data={data} />,
  'hospital.inventory.product-master-report': (data) => <HospitalPharmacy.ProductMasterReportPdf data={data} />,
  'hospital.inventory.product-master-report-excel': (data) => (
    <HospitalPharmacy.ProductMasterReportExcelPdf data={data} />
  ),
  'hospital.inventory.product-ledger': (data) => <HospitalPharmacy.ProductLedgerPdf data={data} />,
  'hospital.inventory.product-ledger.group': (data) => <HospitalPharmacy.ProductLedgerPdf data={data} />,
  'hospital.inventory.product-ledger.subgroup': (data) => <HospitalPharmacy.ProductLedgerPdf data={data} />,
  'hospital.inventory.product-ledger.category': (data) => <HospitalPharmacy.ProductLedgerPdf data={data} />,
  'hospital.inventory.product-ledger.salt': (data) => <HospitalPharmacy.ProductLedgerPdf data={data} />,

  'hospital.inventory.indent-medicine-issue': (data) => <HospitalPharmacy.IndentMedicineIssueReportPdf data={data} />,
  'hospital.inventory.product-tracking-report': (data) => <HospitalPharmacy.ProductTrackingReportPdf data={data} />,
  'hospital.inventory.purchase-requisition-report': (data) => (
    <HospitalPharmacy.PurchaseRequisitionReportPdf data={data} />
  ),
  'hospital.inventory.purchase-order-report': (data) => <HospitalPharmacy.PurchaseOrderReportPdf data={data} />,
  'hospital.inventory.purchase-summary': (data) => <HospitalPharmacy.PurchaseSummaryPdf data={data} />,
  'hospital.inventory.purchase-return-report': (data) => <HospitalPharmacy.PurchaseReturnReportPdf data={data} />,
  'hospital.inventory.stock-transfer-request-report': (data) => (
    <HospitalPharmacy.StockTransferRequestReportPdf data={data} />
  ),
  'hospital.inventory.stock-transfer-report': (data) => <HospitalPharmacy.StockTransferReportPdf data={data} />,
  'hospital.inventory.stock-transfer-accept-report': (data) => (
    <HospitalPharmacy.StockTransferAcceptReportPdf data={data} />
  ),
  'hospital.inventory.stock-transfer-form': (data) => <HospitalPharmacy.StockTransferFormPdf data={data} />,
  'hospital.inventory.stock-adjutment-report': (data) => <HospitalPharmacy.StockAdjutmentReportsPdf data={data} />,
  'hospital.inventory.warehouse-report': (data) => <HospitalPharmacy.WerehouseReportPdf data={data} />,
  'hospital.inventory.batch-wise-item-transaction': (data) => (
    <HospitalPharmacy.BatchWiseItemTransactionPdf data={data} />
  ),
  'hospital.inventory.location-wise-stock-summary': (data) => (
    <HospitalPharmacy.LocationWiseStockSummaryPdf data={data} />
  ),
  'hospital.inventory.monthly-stock-movement-analysis': (data) => (
    <HospitalPharmacy.MonthlyStockMovementAnalysisPdf data={data} />
  ),
  'hospital.inventory.purchase-order': (data) => <HospitalPharmacy.PurchaseOrderPrintPdf data={data} />,
  'hospital.inventory.update-batch-no': (data) => <HospitalPharmacy.UpdateBatchNoPdf data={data} />,
  'hospital.radiology.radiology-status-report': (data) => <HospitalRadiology.RadiologyStatusReportPdf data={data} />,
  'hospital.nurse-module.room-status-report': (data) => <HospitalHMS.RoomStatusReportPdf data={data} />,

  'hospital.inpatient-management.indoor-billing-management.summary': (data) => (
    <HospitalHMS.IndoorBillManagementReportSummaryPdf data={data} />
  ),
  'hospital.inpatient-management.indoor-billing-management.summary1': (data) => (
    <HospitalHMS.IndoorBillManagementReportSummaryPdf1 data={data} />
  ),
  'hospital.inpatient-management.indoor-billing-management.summary2': (data) => (
    <HospitalHMS.IndoorBillManagementSummaryPdf2 data={data} />
  ),
  'hospital.inpatient-management.indoor-billing-management.detail': (data) => (
    <HospitalHMS.IndoorBillManagementReportPdf data={data} />
  ),
  'hospital.inpatient-management.indoor-billing-management.detail1': (data) => (
    <HospitalHMS.IndoorBillManagementDetail1ReportPdf data={data} />
  ),
  'hospital.diet-management.diet-report': (data) => (
    <HospitalHMS.DietReportPdf data={data} />
  ),
  'hospital.ot.ot-entry-register': (data) => (
    <HospitalHMS.OtEntryRegisterPdf data={data} />
  ),
  'hospital.ot.ot-schedule-register': (data) => (
    <HospitalHMS.OtScheduleRegisterPdf data={data} />
  ),
  'hospital.blood-bank.blood-request-status-report': (data) => (
    <HospitalHMS.BloodRequestStatusReportPdf data={data} />
  ),
  'hospital.blood-bank.donor-master-report': (data) => (
    <HospitalHMS.DonorMasterReportPdf data={data} />
  ),
  'hospital.blood-bank.intake-blood-report': (data) => (
    <HospitalHMS.IntakeBloodReportPdf data={data} />

  ),
  'hospital.mis-report.collection-summary': (data) => <HospitalHMS.CollectionSummaryReport data={data} />,
  'hospital.mis-report.collection-summary.user-wise': (data) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} />
  ),
  'hospital.mis-report.consultant-revenue-analysis-report': (data) => (
    <HospitalHMS.ConsultantRevenueAnalysisReportPdf data={data} />
  ),
  'hospital.mis-report.service-register-report': (data) => (
    <HospitalHMS.ServiceRegisterReportPdf data={data} />
  ),
  'hospital.mis-report.refund-register': (data) => <HospitalHMS.RefundRegisterReportPdf data={data} />,
  'hospital.mis-report.credit-register-report': (data) => <HospitalHMS.CreditRegisterReportPdf data={data} />,
  'hospital.mis-report.balance-register-report': (data) => <HospitalHMS.BalanceRegisterReport data={data} />,
  'hospital.mis-report.discount-register-report': (data) => (
    <HospitalHMS.DiscountRegisterReportPdf data={data} />
  ),
  'hospital.mis-report.collection-analysis-report': (data) => (
    <HospitalHMS.CollectionAnalysisReportPdf data={data} />
  ),
  'hospital.mis-report.doctor-ledger': (data) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} />
  ),
  'hospital.mis-report.indoor-collection-register': (data) => (
    <HospitalHMS.IndoorCollectionRegisterReportPdf data={data} />
  ),
  'hospital.doctor-management.doctor-ledger-report': (data) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} />
  ),
  'hospital.outpatient-management.doctor-ledger-report': (data) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} />
  ),
  'hospital.labour-room.ivf-examination': (data) => (
    <HospitalIVF.IVFExaminationPdf data={data} />
  ),
  'hospital.labour-room.ivf-examination.progress-report': (data) => (
    <HospitalIVF.IVFProgressReportPdf data={data} />
  ),
  'hospital.labour-room.ivf-treatement': (data) => (
    <HospitalIVF.IVFTreatementPdf data={data} />
  ),
  'hospital.store-management.purchase-order': (data) => (
    <HospitalStoreManagement.StorePurchaseOrderPrintPdf data={data} />
  ),
  'hospital.radiology.radiology-service-acknowledgement': (data) => <HospitalRadiology.RadioServiceAcknowledgementPdf data={data} />,

  'hospital.radiology.radiology-service-booking': (data) => (
    <HospitalRadiology.RadiologyServiceBookingPdf data={data} />
  ),

  'hospital.inpatient-management.indoor-billing-management.receipt-voucher': (data) => (
    <HospitalHMS.AllReceiptVoucherPdf data={data} />
  ),
  'hospital.inventory.collection-summary': (data) => (
    <HospitalPharmacy.CollectionSummaryReportPdf data={data} />
  ),
  'hospital.radiology.radiology-service-booking-report': (data) => (
    <HospitalRadiology.RadiologyServiceBookingReportPdf data={data} />
  ),
  'hospital.inpatient-management.collection-summary': (data) => (
    <HospitalHMS.CollectionSummaryReport data={data} />
  ),
  'hospital.inpatient-management.collection-summary.user-wise': (data) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} />
  ),
  'hospital.inventory.zero-stock-report': (data) => (
    <HospitalPharmacy.ZeroStockProductPdfReport data={data} />
  ),
  'hospital.inventory.credit-report': (data) => (
    <HospitalPharmacy.CreditPdfReport data={data} />
  ),
  'hospital.tpa.tpa-claim-amount-status-report': (data) => (
    <HospitalTPA.TpaClaimAmountReportStatusPdf data={data} />
  ),
};


export const Print = () => {
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState();

  const getData = useCallback(
    async (path) => {
      const response = await request(path, { method: 'GET', query: { refId: searchParams.get('refId') } }, true);
      if (response?.success) {
        setData(response.data);
      } else {
        toast('Failed to load data', { variant: 'error' });
      }
    },
    [searchParams]
  );

  useEffect(() => {
    getData(pathname);
  }, [pathname, search, getData]);

  // Check if the current route is 'hospital.patient-registeration.patient-registeration'
  if (pathname === '/print/hospital/patient-admission' && data) {
    const DynamicComponent = getDynamicComponent(printOption);
    return <DynamicComponent data={data} />;
  }

  if (pathname === '/print/hospital/outpatient-management/patient-registeration' && data) {
    const DynamicComponent = getDynamicComponent(printOption);
    return <DynamicComponent data={data} />;
  }

  return <>{data && moduleLookup[getPathMode(pathname)](data)}</>;
};
